module.exports = __webpack_public_path__ + "img/4.ad0cf358.png";